import Vue from "vue";
import axios from "axios";
import socket from "@/socket";
// import { domain } from "@/env";
import Media from '@/components/common/media'

Vue.component('Media', Media)



const domain = "https://api.caixukang.cn/";

axios.defaults.baseURL = domain;
axios.defaults.headers["Content-Type"] =
    "application/x-www-form-urlencoded;charset=UTF-8";
Vue.mixin({
    methods: {
        // 下载Excel文件流
        downloadFile(url, data, fileName) {
            let _self = this;
            return new Promise((resolve, reject) => {
                //qs.stringify()将对象序列化成URL的形式，以&进行拼接
                axios
                    .post(url, _self.qs.stringify(data), {
                        responseType: "blob"
                    })
                    .then(res => {
                        if (res.data.size) {
                            resolve(res.data);
                            let blob = new Blob([res.data], {
                                type: "application/vnd.ms-excel"
                            });
                            let link = document.createElement("a");
                            link.innerHTML = fileName;
                            link.download = fileName;
                            link.href = URL.createObjectURL(blob);
                            link.click();
                        } else {
                            _self.$message.error(res.data.message);
                        }
                    })
                    .catch(function (error) {
                        resolve(error);
                        _self.$message.error('下载失败');
                    });
            });
        },
        goback() {
            this.$router.go(-1);
        },
        sendSock(scene, data, callback) {
            socket.send({
                scene: scene,
                data: data,
            }, callback);
        }
    }
});



// WEBPACK FOOTER //
// ./src/mixin/index.js